import React, { useMemo, useState, useEffect, useRef } from "react";
import { steps } from "./todoConstant";
import AccordionTodo from "./Accordian";

const TodoSteps = React.memo(({ cards, scrollToCardId, height }) => {
  const haveOpenCards = cards?.filter(
    (card) => card.card.todo_column === steps[0].name
  );
  const [expanded, setExpanded] = useState(
    haveOpenCards?.length && steps[0].name
  );
  const prevCardsRef = useRef(null);
  const isInitialMountRef = useRef(true);

  const isHideAccepted = cards.filter(
    (card) => card.card.todo_column === "Accepted"
  )?.length;

  const stepInfo = useMemo(() => {
    return steps.reduce((acc, step) => {
      const stepCards = cards.filter(
        (card) => card.card.todo_column === step.name
      );
      acc[step.name] = {
        hasCards: stepCards.length > 0,
        cardCount: stepCards.length,
      };
      return acc;
    }, {});
  }, [cards]);

  // Detect status changes and manage accordions
  useEffect(() => {
    // Skip on initial mount
    if (isInitialMountRef.current) {
      isInitialMountRef.current = false;
      prevCardsRef.current = cards;
      return;
    }
    
    const prevCards = prevCardsRef.current;
    
    // Find cards that changed status
    const statusChangedCards = cards.filter((currentCard) => {
      const prevCard = prevCards?.find(
        (p) => p.card.card_id === currentCard.card.card_id
      );
      
      if (!prevCard) return false;
      
      const prevStatus = prevCard.card.todo_column;
      const currentStatus = currentCard.card.todo_column;
      
      return prevStatus !== currentStatus;
    });

    // If any card changed status, update accordion
    if (statusChangedCards.length > 0) {
      const changedCard = statusChangedCards[0]; // Get the first changed card
      const newStatus = changedCard.card.todo_column;
      
      // Check if the new status accordion has cards
      const newStatusCards = cards.filter(
        (card) => card.card.todo_column === newStatus
      );
      
      // Only update if the new status has cards
      if (newStatusCards.length > 0) {
        setExpanded(newStatus);
      }
    }
    
    // Update ref for next comparison
    prevCardsRef.current = cards;
  }, [cards]);

  const handleAccordionChange = (val) => {
    setExpanded((prev) => (val === prev ? "" : val));
  };

  return (
    <div style={{ marginTop: "-6px" }}>
      {steps.map((step, idx) => (
        <AccordionTodo
          key={idx}
          heading={step.name}
          uniqueKey={idx}
          expanded={expanded}
          scrollToCardId={scrollToCardId}
          stepInfo={stepInfo}
          onChange={handleAccordionChange}
          cards={cards.filter((card) => card.card.todo_column === step.name)}
          sx={
            step.name === "Completed" && !isHideAccepted
              ? { ...step.sx, bottom: "0px" }
              : step.sx
          }
          height={height}
        />
      ))}
    </div>
  );
});

export default TodoSteps;
